import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Container, Row, Col, Card, CardHeader, CardBody, Button, Modal, ModalHeader, ModalBody, ModalFooter, Alert, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Label } from 'reactstrap';
import CountUp from 'react-countup';
import axios from 'axios';
import TableContainer from '../../../Components/Common/TableContainer';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import DeleteModal from '../../../Components/Common/DeleteModal';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import 'moment/locale/fr';
import api,{handleApiError} from '../../../helpers/api';
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";


// Custom CSS for design inspired by AllOrders
const customStyles = `
  .faq-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  .faq-modal .modal-content {
    border-radius: 8px;
    border: none;
  }
  .faq-modal .modal-header {
    background: linear-gradient(135deg, #2a4966 0%, #0ab39c 100%);
    color: #ffffff;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 1.5rem;
  }
  .faq-modal .modal-header h5 {
    font-weight: 600;
    font-size: 1.4rem;
    color: #ffffff;
  }
  .faq-modal .modal-body {
    padding: 1.5rem;
    background-color: #f9fafb;
  }
  .faq-modal .modal-body p {
    color: #333;
    font-size: 1rem;
    line-height: 1.6;
  }
  .faq-modal .modal-body strong {
    color: #2a4966;
  }
  .answer-modal .modal-content {
    border-radius: 8px;
    border: none;
  }
  .answer-modal .modal-header {
    background: linear-gradient(135deg, #2a4966 0%, #0ab39c 100%);
    color: #ffffff;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 1.5rem;
  }
  .answer-modal .modal-header h5 {
    font-weight: 600;
    font-size: 1.4rem;
    color: #ffffff;
  }
  .answer-modal .modal-body {
    padding: 1.5rem;
    background-color: #f9fafb;
  }
  .answer-modal .modal-body textarea {
    width: 100%;
    min-height: 100px;
    border-radius: 4px;
    border: 1px solid #ced4da;
    padding: 0.5rem;
    font-size: 1rem;
    resize: vertical;
  }
  .answer-modal .modal-body textarea:focus {
    border-color: #0ab39c;
    box-shadow: 0 0 0 0.2rem rgba(10, 179, 156, 0.25);
  }
  .faq-table th, .faq-table td {
    vertical-align: middle;
    padding: 0.75rem;
  }
  .faq-table tr:hover {
    background-color: #f1f5f7;
  }
  .faq-widget-card {
    transition: transform 0.3s ease;
  }
  .faq-widget-card:hover {
    transform: translateY(-5px);
  }
  .filter-container {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: center;
    flex-wrap: nowrap;
    overflow-x: auto;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
  }
  .filter-container .form-control,
  .filter-container .form-select {
    border-radius: 4px;
    border: 1px solid #ced4da;
    min-width: 150px;
    font-size: 0.9rem;
    padding: 0.5rem 1rem;
  }
  .filter-container .form-control:focus,
  .filter-container .form-select:focus {
    border-color: #0ab39c;
    box-shadow: 0 0 0 0.2rem rgba(10, 179, 156, 0.25);
  }
  .action-btn {
    font-size: 0.85rem;
    padding: 0.4rem 0.8rem;
    transition: background-color 0.3s ease, transform 0.2s ease;
  }
  .action-btn:hover {
    transform: translateY(-2px);
  }
  .new-badge {
    margin-left: 0.5rem;
    font-size: 0.75rem;
    vertical-align: middle;
  }
  .card-header {
    background-color: transparent;
    border-bottom: 1px solid #e9ecef;
    padding: 1rem 1.5rem;
  }
  .card-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #2a4966;
  }
  .dropdown-menu {
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    border: none;
  }
  .dropdown-item {
    font-size: 0.85rem;
    padding: 0.5rem 1rem;
    color: #2a4966;
  }
  .dropdown-item:hover {
    background-color: #f1f5f7;
    color: #0ab39c;
  }
  .dropdown-item i {
    margin-right: 0.5rem;
  }
  .dropdown-item.disabled {
    color: #6c757d;
    pointer-events: none;
    background-color: transparent;
  }
  @media (max-width: 768px) {
    .faq-modal .modal-body,
    .answer-modal .modal-body {
      padding: 1rem;
    }
    .filter-container {
      flex-wrap: nowrap;
      overflow-x: auto;
    }
    .filter-container .form-control,
    .filter-container .form-select {
      min-width: 120px;
      font-size: 0.85rem;
    }
  }
`;

const FAQList = () => {
    const { t, i18n } = useTranslation();
    document.title = t('faq_list.title');

    const [faqs, setFaqs] = useState([]);
    const [filteredFaqs, setFilteredFaqs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [viewModal, setViewModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [answerModal, setAnswerModal] = useState(false);
    const [selectedFaq, setSelectedFaq] = useState(null);
    const [answerText, setAnswerText] = useState('');
    const [filterStatus, setFilterStatus] = useState('all');
    const [sortOrder, setSortOrder] = useState('desc');
    const [searchQuery, setSearchQuery] = useState('');
    const [dropdownOpen, setDropdownOpen] = useState({});
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Set moment locale based on i18next language
    useEffect(() => {
        moment.locale(i18n.language);
    }, [i18n.language]);

    // Fetch FAQs from backend
    const fetchFaqs = useCallback(async () => {
        try {
            setIsLoading(true);
            const response = await api.get('/faq', {
                withCredentials: true,
            });
            setFaqs(response.data.data);
            setFilteredFaqs(response.data.data);
            setIsLoading(false);
        } catch (err) {
            if (err.response.data?.status === 401 || err.response.data?.status === 403) {
                await handleApiError(err, dispatch, navigate);
            } else {
                setError(t('faq_list.error_fetch'));
                setIsLoading(false);
                toast.error(t('faq_list.error_fetch_toast'));
            }
        }
    }, [t, dispatch, navigate]);
    useEffect(() => {
        fetchFaqs();
    }, [fetchFaqs]);

    // Filter and Sort FAQs
    useEffect(() => {
        let updatedFaqs = [...faqs];
        // Apply search filter
        if (searchQuery) {
            updatedFaqs = updatedFaqs.filter(faq =>
                (faq.name?.toLowerCase().includes(searchQuery.toLowerCase()) || '') ||
                (faq.email?.toLowerCase().includes(searchQuery.toLowerCase()) || '') ||
                (faq.question?.toLowerCase().includes(searchQuery.toLowerCase()) || '')
            );
        }
        // Apply status filter
        if (filterStatus !== 'all') {
            updatedFaqs = updatedFaqs.filter(faq => faq.treated === (filterStatus === 'treated'));
        }
        // Apply sort order
        updatedFaqs.sort((a, b) => {
            const dateA = new Date(a.createdAt || Date.now());
            const dateB = new Date(b.createdAt || Date.now());
            return sortOrder === 'desc' ? dateB - dateA : dateA - dateB;
        });
        setFilteredFaqs(updatedFaqs);
    }, [faqs, filterStatus, sortOrder, searchQuery]);

    // Widgets data
    const faqWidgets = useMemo(() => [
        {
            title: t('faq_list.widgets.total_faqs'),
            counter: faqs.length,
            suffix: '',
            decimals: 0,
            percentage: '0%',
            percentageClass: 'success',
            arrowIcon: 'ri-arrow-up-line',
            icon: 'ri-question-line',
        },
        {
            title: t('faq_list.widgets.treated_faqs'),
            counter: faqs.filter(faq => faq.treated).length,
            suffix: '',
            decimals: 0,
            percentage: '0%',
            percentageClass: 'success',
            arrowIcon: 'ri-arrow-up-line',
            icon: 'ri-checkbox-circle-line',
        },
        {
            title: t('faq_list.widgets.untreated_faqs'),
            counter: faqs.filter(faq => !faq.treated).length,
            suffix: '',
            decimals: 0,
            percentage: '0%',
            percentageClass: 'danger',
            arrowIcon: 'ri-arrow-down-line',
            icon: 'ri-alert-line',
        },
    ], [faqs, t]);

    // Handle Answer FAQ
    const handleAnswerFaq = async () => {
        if (!answerText.trim()) {
            toast.error(t('faq_list.error_empty_answer'));
            return;
        }

        try {
            await api.patch(
                `/faq/${selectedFaq._id}/treat`,
                { answer: answerText },
                { withCredentials: true }
            );
            toast.success(t('faq_list.success_answer'));
            setAnswerModal(false);
            setAnswerText('');
            fetchFaqs();
        } catch (err) {
            if (err.response.data?.status === 401 || err.response.data?.status === 403) {
                await handleApiError(err, dispatch, navigate);
            } else {
                toast.error(t('faq_list.error_answer'));
            }
        }
    };

    // Handle Delete
    const handleDeleteFaq = async () => {
        try {
            await api.delete(`/faq/${selectedFaq._id}`, {
                withCredentials: true,
            });
            toast.success(t('faq_list.success_delete'));
            setDeleteModal(false);
            fetchFaqs();
        } catch (err) {
            if (err.response?.status === 401 || err.response?.status === 403) {
                await handleApiError(err, dispatch, navigate);
            } else {
                toast.error(t('faq_list.error_delete'));
            }
        }
    };
    // Handle View
    const handleViewClick = (faq) => {
        setSelectedFaq(faq);
        setViewModal(true);
    };

    // Handle Answer
    const handleAnswerClick = (faq) => {
        if (faq.treated) {
            toast.warning(t('faq_list.warning_already_treated'));
            return;
        }
        setSelectedFaq(faq);
        setAnswerModal(true);
    };

    // Handle Delete
    const handleDeleteClick = (faq) => {
        setSelectedFaq(faq);
        setDeleteModal(true);
    };

    // Toggle dropdown for a specific row
    const toggleDropdown = (id) => {
        setDropdownOpen(prev => ({ ...prev, [id]: !prev[id] }));
    };

    const isToday = (createdAt) => {
   const today = new Date();
        const faqDate = new Date(createdAt);
        return faqDate.toLocaleDateString() === today.toLocaleDateString();
    };

    // Table Columns
    const columns = useMemo(
        () => [
            {
                Header: t('faq_list.table.name'),
                accessor: 'name',
                filterable: true,
                Cell: ({ value }) => <span>{value}</span>,
            },
            {
                Header: t('faq_list.table.email'),
                accessor: 'email',
                filterable: true,
                Cell: ({ value }) => <span>{value}</span>,
            },
            {
                Header: t('faq_list.table.question'),
                accessor: 'question',
                filterable: true,
                Cell: ({ value }) => <span>{value ? (value.length > 50 ? `${value.substring(0, 50)}...` : value) : '-'}</span>,
            },
            {
                Header: t('faq_list.table.status'),
                accessor: 'treated',
                filterable: true,
                Cell: ({ value, row }) => (
                    <span>
                        <span className={`badge badge-soft-${value ? 'success' : 'warning'} text-uppercase`}>
                            {value ? t('faq_list.table.treated') : t('faq_list.table.untreated')}
                        </span>
                        {!value && isToday(row.original.createdAt) && (
                            <span className="badge badge-soft-info new-badge">{t('faq_list.table.new')}</span>
                        )}
                    </span>
                ),
            },
            {
                Header: t('faq_list.table.actions'),
                Cell: ({ row }) => (
                    <Dropdown
                        isOpen={dropdownOpen[row.original._id] || false}
                        toggle={() => toggleDropdown(row.original._id)}
                    >
                        <DropdownToggle tag="button" className="btn btn-soft-secondary action-btn">
                            <i className="ri-more-2-fill"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() => handleViewClick(row.original)}>
                                <i className="ri-eye-fill me-1"></i> {t('faq_list.table.view')}
                            </DropdownItem>
                            <DropdownItem
                                onClick={() => handleAnswerClick(row.original)}
                                className={row.original.treated ? 'disabled' : ''}
                            >
                                <i className="ri-chat-3-line me-1"></i> {t('faq_list.table.answer_faq')}
                            </DropdownItem>
                            <DropdownItem onClick={() => handleDeleteClick(row.original)}>
                                <i className="ri-delete-bin-fill me-1"></i> {t('faq_list.table.delete')}
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                ),
            },
        ],
        [dropdownOpen, t]
    );

    return (
        <React.Fragment>
            <style>{customStyles}</style>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={t('faq_list.breadcrumb_title')} pageTitle={t('faq_list.breadcrumb_page_title')} />
                    {/* Widgets Section */}
                    <Row>
                        {faqWidgets.map((item, key) => (
                            <Col xxl={4} sm={6} key={key}>
                                <Card className="faq-widget-card card-animate">
                                    <CardBody>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <p className="fw-medium text-muted mb-0">{item.title}</p>
                                                <h2 className="mt-4 ff-secondary fw-semibold">
                                                    <span className="counter-value">
                                                        <CountUp
                                                            start={0}
                                                            end={item.counter}
                                                            duration={3}
                                                            suffix={item.suffix}
                                                            decimals={item.decimals}
                                                        />
                                                    </span>
                                                </h2>
                                                <p className="mb-0 text-muted">
                                                    <span className={`badge bg-light text-${item.percentageClass} mb-0`}>
                                                        <i className={`${item.arrowIcon} align-middle`}></i> {item.percentage}
                                                    </span> {t('faq_list.widgets.vs_previous_month')}
                                                </p>
                                            </div>
                                            <div>
                                                <div className="avatar-sm flex-shrink-0">
                                                    <span className="avatar-title bg-soft-info text-info rounded-circle fs-4">
                                                        <i className={item.icon}></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                    {/* FAQs Table */}
                    <Row>
                        <Col lg={12}>
                            <Card className="faq-card">
                                <CardHeader className="d-flex align-items-center border-0">
                                    <h5 className="card-title mb-0 flex-grow-1">{t('faq_list.card_title')}</h5>
                                    <div className="flex-shrink-0">
                                        <div className="filter-container hstack gap-2">
                                            <Input
                                                type="text"
                                                placeholder={t('faq_list.search_placeholder')}
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                                className="form-control"
                                            />
                                            <Input
                                                type="select"
                                                className="form-select"
                                                value={filterStatus}
                                                onChange={(e) => setFilterStatus(e.target.value)}
                                            >
                                                <option value="all">{t('faq_list.filter_all_statuses')}</option>
                                                <option value="treated">{t('faq_list.filter_treated')}</option>
                                                <option value="untreated">{t('faq_list.filter_untreated')}</option>
                                            </Input>
                                            <Input
                                                type="select"
                                                className="form-select"
                                                value={sortOrder}
                                                onChange={(e) => setSortOrder(e.target.value)}
                                            >
                                                <option value="desc">{t('faq_list.sort_newest')}</option>
                                                <option value="asc">{t('faq_list.sort_oldest')}</option>
                                            </Input>
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    {isLoading ? (
                                        <div className="text-center py-4">
                                            <i className="ri-loader-2-line fs-24 text-primary spin"></i>
                                        </div>
                                    ) : error ? (
                                        <Alert color="danger">{error}</Alert>
                                    ) : (
                                        <TableContainer
                                            columns={columns}
                                            data={filteredFaqs}
                                            isGlobalFilter={false}
                                            customPageSize={8}
                                            className="custom-header-css"
                                            divClass="table-responsive table-card mb-1"
                                            tableClass="align-middle table-nowrap"
                                            theadClass="table-light text-muted"
                                            thClass=""
                                        />
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    {/* View Modal */}
                    <Modal
                        isOpen={viewModal}
                        toggle={() => setViewModal(false)}
                        centered
                        className="faq-modal"
                    >
                        <ModalHeader
                            toggle={() => setViewModal(false)}
                            className="p-3"
                        >
                            {t('faq_list.view_modal_title')}
                        </ModalHeader>
                        <ModalBody>
                            {selectedFaq && (
                                <div>
                                    <h5 className="mb-3">{t('faq_list.view_modal_customer_info')}</h5>
                                    <p><strong>{t('faq_list.view_modal_name')}:</strong> {selectedFaq.name}</p>
                                    <p><strong>{t('faq_list.view_modal_email')}:</strong> {selectedFaq.email}</p>
                                    <p><strong>{t('faq_list.view_modal_question')}:</strong> {selectedFaq.question || '-'}</p>
                                    <p><strong>{t('faq_list.view_modal_status')}:</strong> {selectedFaq.treated ? t('faq_list.table.treated') : t('faq_list.table.untreated')}</p>
                                    {selectedFaq.createdAt && (
                                        <p><strong>{t('faq_list.view_modal_submitted')}:</strong> {selectedFaq.createdAt ? moment(selectedFaq.createdAt).format('DD/MM/YYYY HH:mm') : t('faq_list.na')}</p>
                                    )}
                                    {selectedFaq.treated && selectedFaq.answer && (
                                        <p><strong>{t('faq_list.view_modal_answer')}:</strong> {selectedFaq.answer}</p>
                                    )}
                                </div>
                            )}
                        </ModalBody>
                    </Modal>
                    {/* Answer Modal */}
                    <Modal
                        isOpen={answerModal}
                        toggle={() => setAnswerModal(false)}
                        centered
                        className="answer-modal"
                    >
                        <ModalHeader toggle={() => setAnswerModal(false)} className="p-3">
                            {t('faq_list.answer_modal_title')}
                        </ModalHeader>
                        <ModalBody>
                            {selectedFaq && (
                                <div>
                                    <h5 className="mb-3">{t('faq_list.view_modal_customer_info')}</h5>
                                    <p><strong>{t('faq_list.view_modal_name')}:</strong> {selectedFaq.name}</p>
                                    <p><strong>{t('faq_list.view_modal_email')}:</strong> {selectedFaq.email}</p>
                                    <p><strong>{t('faq_list.view_modal_question')}:</strong> {selectedFaq.question || '-'}</p>
                                    <Label className="mt-3">{t('faq_list.answer_modal_help')}</Label>
                                    <textarea
                                        value={answerText}
                                        onChange={(e) => setAnswerText(e.target.value)}
                                        placeholder={t('faq_list.answer_modal_placeholder')}
                                    />
                                </div>
                            )}
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={() => setAnswerModal(false)}>
                                {t('faq_list.cancel_button')}
                            </Button>
                            <Button color="primary" onClick={handleAnswerFaq}>
                                {t('faq_list.answer_button')}
                            </Button>
                        </ModalFooter>
                    </Modal>
                    {/* Delete Modal */}
                    <DeleteModal
                        show={deleteModal}
                        onDeleteClick={handleDeleteFaq}
                        onCloseClick={() => setDeleteModal(false)}
                    />
                    <ToastContainer closeButton={false} limit={1} />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default FAQList;